export enum PositionType {
  "TOPRIGHT" = "topright",
  "TOPLEFT" = "topleft",
  "BOTTOMRIGHT" = "bottomright",
  "BOTTOMLEFT" = "bottomleft",
}

export enum IndustryModuleType {
  // 经营情况
  YE_JI = "YE_JI",
  // 网点分析
  WANG_DIAN = "WANG_DIAN",
  // 周边生态
  HUO_KE = "HUO_KE",
  // 场景拓客
  XUN_KE = "XUN_KE",
  // 客群提升
  YING_XIAO = "YING_XIAO",
  // 智能选址
  XUAN_ZHI = "XUAN_ZHI",
  // 客情管理
  KE_QING = "KE_QING",
  // 竞品追踪
  ZHUI_ZONG = "ZHUI_ZONG",
  // 网格洞察
  INSIGHTS = "INSIGHTS",
  // 星巴克-选址
  SITE_SELECTION = "SITE_SELECTION",
  // 星巴克-门店对比
  STORE_COMPARISON = "STORE_COMPARISON",
  // 区域洞察
  AREA_INSIGHTS = "AREA_INSIGHTS",
  // 门店大盘
  SHOP_DASHBOARD = "SHOP_DASHBOARD",
}

// 经营情况-菜单
export enum PerformanceCustomerType {
  // 综合分析
  FEN_XI = "FEN_XI",
  // 网点概览
  GAI_LAN = "GAI_LAN",
  // 经营指标
  JING_YING = "JING_YING",
  // 产品指标
  CHAN_PIN = "CHAN_PIN",
  // 对公账户
  DUI_GONG = "DUI_GONG",
  // 个人客户
  GE_REN = "GE_REN",
}

// 排序类型
export enum SceneSortType {
  /**
   * 企业合作
   */
  OPEN_DATE = "OPEN_DATE", // 成立日期
  CAPITAL = "CAPITAL", // 注册资本
  /**
   * 物业合作
   */
  HOUSE_PRICE = "HOUSE_PRICE", // 房价
  ESTATE_PEOPLE_CNT = "ESTATE_PEOPLE_CNT", // 小区人口数
  /**
   * 商户收单
   */
  VISIT_FLOW = "VISIT_FLOW", // 到访客流
  RESIDENTIAL = "RESIDENTIAL", // 常驻人口
}

// 场景拓客类型
export enum SceneCustomerType {
  // 商户
  BUSINESS = "BUSINESS",
  // 小区
  PROPERTY_COMPANY = "PROPERTY_COMPANY",
  // 企业
  COMPANY = "COMPANY",
  // 农村
  RURAL_AREA = "RURAL_AREA",
  // 政府
  GOVERNMENT = "GOVERNMENT",
  // 专精特新
  SPECIALIZATION = "SPECIALIZATION",
  // 大数据中心
  BIG_DATA_CENTER = "BIG_DATA_CENTER",
}

// 筛选类型
export enum SceneCustomerQueryType {
  /**
   * 市、区、街道
   */
  CITY_RANGE = "CITY_RANGE",
  /**
   * 网点
   */
  STORE = "STORE",
}

export enum IndustryDataRange {
  /**
   * 网点范围
   */
  STORE_RANGE = "STORE_RANGE",
  /**
   * 城市范围
   */
  CITY_RANGE = "CITY_RANGE",
  /**
   * 区县范围
   */
  DISTRICT_RANGE = "DISTRICT_RANGE",
}

// 商户类型
export enum SceneCustomerBusinessTag {
  // 餐饮
  RESTAURANT = "RESTAURANT",
  // 购物
  SHOPPING = "SHOPPING",
}

// 商户合作状态
export enum BusinessCooStatus {
  /**
   * 已合作
   */
  COOPERATION = "COOPERATION",
  /**
   * 未合作
   */
  NO_COOPERATION = "NO_COOPERATION",
  /**
   * 已建联
   */
  CONTACT = "CONTACT",
}

// 客流过滤方式
export enum FlowFilterUnit {
  // 百分比
  PERCENT = "PERCENT",
  // top多少名
  TOP = "TOP",
}

// 指数类型
export enum FlowFilterType {
  // 到访指数
  VISIT_RATIO = "VISIT_RATIO",
  // 常驻指数
  RESIDENT_RATIO = "RESIDENT_RATIO",
}

// 商户排序类型
export enum BusinessSceneSortType {
  // 到访客流
  VISIT_FLOW = "VISIT_FLOW",
  // 常驻人口
  RESIDENT_FLOW = "RESIDENT_FLOW",
}

// 企业联系方式
export enum CompanyPriorityRecommendType {
  // 有联系电话企业
  PHONE = "PHONE",
  // 无联系电话企业
  NONE = "NONE",
}

export enum IndustryLevelType {
  // 一级行业分类
  L1 = "L1",
  // 一二三级行业分类
  L123 = "L123",
}

// 产品版本号（公司企业专用）
export enum ProductVersion {
  V15 = "V15",
}

// 政府机构
export enum GovQueryType {
  /**
   * 中央政府机关
   */
  CENTRAL_GOV = "CENTRAL_GOV",
  /**
   * 省级政府机关
   */
  PROVINCE_GOV = "PROVINCE_GOV",
  /**
   * 市级政府机关
   */
  CITY_GOV = "CITY_GOV",
  /**
   * 区县级机关
   */
  DISTRICT_GOV = "DISTRICT_GOV",
  /**
   * 乡镇级机关
   */
  VILLAGE_GOV = "VILLAGE_GOV",
  /**
   * 村级单位
   */
  RURAL_GOV = "RURAL_GOV",
}

// 工商税务机构
export enum CommerceTaxQueryType {
  /**
   * 国税机关
   */
  STATE_TAX = "STATE_TAX",
  /**
   * 地税机关
   */
  LOCAL_TAX = "LOCAL_TAX",
  /**
   * 工商部门
   */
  COMMERCE = "COMMERCE",
}

// DialogProfile组件componentType枚举值
export enum DialogProfileType {
  // 周边生态，店铺
  ECO_SHOP = "ECO_SHOP",
  // 场景拓客，店铺
  MALL_SHOP = "MALL_SHOP",
  // 场景拓客，农村
  RURAL_SHOP = "RURAL_SHOP",
}

// 用户权限
export enum RoleAuthStrategy {
  // 沙盘数据读取编辑权限
  INDUSTRY_DATA_AUTHORITY = "INDUSTRY_DATA_AUTHORITY",
  // 多用户操作权限
  MULTI_USER_OPERATION = "MULTI_USER_OPERATION",
}

// 合作方式：商户，公司
export enum BusinessCooMode {
  // 信用卡
  CREDIT_CARD = "CREDIT_CARD",
  // 存款
  DEPOSIT = "DEPOSIT",
  // 贷款
  LOAN = "LOAN",
  // 收单
  BUSINESS = "BUSINESS",
  // 薪资代发
  SALARY = "SALARY",
}

// 选址分析状态
export enum SiteAnalysisStatus {
  // 分析成功
  ANALYSE_SUCCESS = "ANALYSE_SUCCESS",
  // 分析失败
  ANALYSE_FAILURE = "ANALYSE_FAILURE",
  // 分析中
  ANALYSING = "ANALYSING",
}

// 选址方式
export enum SiteChooseWay {
  // 选址评分
  SITE_SCORE = "SITE_SCORE",
  // 自定义
  CUSTOMIZATION = "CUSTOMIZATION",
  // 系统推荐
  SYSTEM_RECOMMEND = "SYSTEM_RECOMMEND",
}

// 融资轮次
export enum FinancingRoundsType {
  // 不限
  ALL = "ALL",
  // A轮
  A = "A",
  // B轮
  B = "B",
  // C轮
  C = "C",
  // D轮
  D = "D",
  // E轮
  E = "E",
  // F轮
  F = "F",
  // 上市公司
  LISTED = "LISTED",
  // 其他
  OTHER = "OTHER",
}

// 选址限制条件
export enum SiteSelectionRestrictionCondition {
  // 数量大于
  QUANITTY_GT = "QUANITTY_GT",
  // 数量大于等于
  QUANITTY_GTE = "QUANITTY_GTE",
  // 数量小于
  QUANITTY_LT = "QUANITTY_LT",
  // 数量小于等于
  QUANITTY_LTE = "QUANITTY_LTE",
}

// 客情管理
export enum TrailArgsSort {
  // 个人达标率分析页面
  STORE_ASC = "STORE_ASC", // 门店达标率升序
  STORE_DESC = "STORE_DESC", // 门店达标率降序
  DURATION_ASC = "DURATION_ASC", // 拜访时长达标率升序
  DURATION_DESC = "DURATION_DESC", // 拜访时长达标率降序
  COUNT_ASC = "COUNT_ASC", // 拜访频次达标率升序
  COUNT_DESC = "COUNT_DESC", // 拜访频次达标率降序
  AVERAGE_ASC = "AVERAGE_ASC", // 门店平均拜访时长升序
  AVERAGE_DESC = "AVERAGE_DESC", // 门店平均拜访时长升序
  // 门店达标率页面
  TARGET_COUNT_ASC = "TARGET_COUNT_ASC", // 额定门店数升序
  TARGET_COUNT_DESC = "TARGET_COUNT_DESC", // 额定门店数降序
  ACTUAL_COUNT_ASC = "ACTUAL_COUNT_ASC", // 实际门店数升序
  ACTUAL_COUNT_DESC = "ACTUAL_COUNT_DESC", // 实际门店数降序
  MISSED_COUNT_ASC = "MISSED_COUNT_ASC", // 非额定门店数升序
  MISSED_COUNT_DESC = "MISSED_COUNT_DESC", // 非额定门店数降序
  RATIO_ASC = "RATIO_ASC", // 达标率升序
  RATIO_DESC = "RATIO_DESC", // 达标率降序
  // 拜访时长达标率页面
  TOTAL_DURATION_ASC = "TOTAL_DURATION_ASC", // 总停留时长升序
  TOTAL_DURATION_DESC = "TOTAL_DURATION_DESC", // 总停留时长降序
  AVERAGE_DURATION_ASC = "AVERAGE_DURATION_ASC", // 平均停留时长升序
  AVERAGE_DURATION_DESC = "AVERAGE_DURATION_DESC", // 平均停留时长降序
  MAX_DURATION_ASC = "MAX_DURATION_ASC", // 最长停留时长升序
  MAX_DURATION_DESC = "MAX_DURATION_DESC", // 最长停留时长降序
  MIN_DURATION_ASC = "MIN_DURATION_ASC", // 最短停留时长升序
  MIN_DURATION_DESC = "MIN_DURATION_DESC", // 最短停留时长降序
  // 拜访频次达标率页面
  TOTAL_VISIT_COUNT_ASC = "TOTAL_VISIT_COUNT_ASC", // 总频次升序
  TOTAL_VISIT_COUNT_DESC = "TOTAL_VISIT_COUNT_DESC", // 总频次降序
  AVERAGE_VISIT_COUNT_ASC = "AVERAGE_VISIT_COUNT_ASC", // 平均次数升序
  AVERAGE_VISIT_COUNT_DESC = "AVERAGE_VISIT_COUNT_DESC", // 平均次数降序
  MAX_VISIT_COUNT_ASC = "MAX_VISIT_COUNT_ASC", // 最多次数升序
  MAX_VISIT_COUNT_DESC = "MAX_VISIT_COUNT_DESC", // 最多次数降序
  MIN_VISIT_COUNT_ASC = "MIN_VISIT_COUNT_ASC", // 最少次数升序
  MIN_VISIT_COUNT_DESC = "MIN_VISIT_COUNT_DESC", // 最少次数降序
  // 门店平均拜访时长页面
  VISIT_COUNT_ASC = "VISIT_COUNT_ASC", // 拜访次数升序
  VISIT_COUNT_DESC = "VISIT_COUNT_DESC", // 拜访次数降序
  VISIT_TIME_ASC = "VISIT_TIME_ASC", // 拜访时间升序
  VISIT_TIME_DESC = "VISIT_TIME_DESC", // 拜访时间降序
  AVERAGE_TIME_ASC = "AVERAGE_TIME_ASC", // 平均时间升序
  AVERAGE_TIME_DESC = "AVERAGE_TIME_DESC", // 平均时间降序
}

// 品牌类型
export enum IndustryCategory {
  // 银行
  BANK = "BANK",
  // 广告行业
  ADVERTISEMENT = "ADVERTISEMENT",
  // 其他
  OTHER = "OTHER",
}

// 画像Tag
export enum ProfileTag {
  // 人群分析
  POPULATION_ANALYSIS = "POPULATION_ANALYSIS",
  // 维护信息
  MAINTAIN_INFO = "MAINTAIN_INFO",
  // 拜访记录
  VISIT_RECORD = "VISIT_RECORD",
  // 生态信息
  ECOLOGY_INFO = "ECOLOGY_INFO",
}

// 沙盘类型
export enum SandtableType {
  // 金融
  FINANCE = "FINANCE",
  // 园区
  PARK = "PARK",
  // 品牌
  BRAND = "BRAND",
  // 零售
  RETAIL = "RETAIL",
}

// 沙盘分类
export enum SandtableCategory {
  // 系统
  SYSTEM = "SYSTEM",
  // 自定义
  CUSTOM = "CUSTOM",
}
